import React, { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '@ui/Button';
import Icon from '@ui/Icon';
import { StudioClipContext } from '../StudioClip';
import StudioClipAction, { StudioClipActionProps } from './StudioClipAction';
import StudioClipActionTooltip from './StudioClipActionTooltip';

const DELETE_BADGE_SIZE = 24;

const useStyles = makeStyles()(theme => ({
  desktop: {
    // Remove hit target padding if focusing so styling looks better
    '&.Mui-focusVisible': {
      padding: theme.spacing(1),
      margin: 0,
    },
    // increase the hit target for the button to that hovering
    // to the badge feels more natural
    margin: theme.spacing(-0.5, -0.5, 0, 0),
    padding: theme.spacing(1.5, 1.5, 1, 1),
    '&:hover + span': {
      display: 'flex',
    },
  },
  badge: {
    display: 'flex',
    cursor: 'default',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: (DELETE_BADGE_SIZE / 3) * -1,
    right: (DELETE_BADGE_SIZE / 3) * -1,
    height: DELETE_BADGE_SIZE,
    minWidth: DELETE_BADGE_SIZE,
    borderRadius: DELETE_BADGE_SIZE,
    backgroundColor: theme.palette.background.paper,
    boxShadow: `0 0 8px 0 rgba(0,0,0,0.75)`,
  },
  tooltip: {
    maxWidth: 120,
  },
  iconButton: {
    width: 'fit-content',
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));
interface StudioClipActionDeleteProps extends StudioClipActionProps {
  showCanCredit?: boolean;
  onClick(): void;
  className?: string;
}

const StudioClipActionDelete = ({
  className,
  showCanCredit,
  onClick,
  ...restProps
}: StudioClipActionDeleteProps) => {
  const { clip, breakpoint, audio } = useContext(StudioClipContext);
  const { classes } = useStyles();

  if (!clip) return null;

  const onClickPauseAudio = () => {
    if (audio) audio.pause();
    // call onClick function passed through on props
    onClick();
  };

  return breakpoint === 'xs' ? (
    <StudioClipAction.Mobile
      {...restProps}
      onClick={onClickPauseAudio}
      menuItemText="Delete"
      aria-label="delete clip"
    >
      <Icon type="delete" />
    </StudioClipAction.Mobile>
  ) : (
    <StudioClipActionTooltip placement="bottom" title="Delete">
      <Button
        variant="icon"
        className={classes.iconButton}
        aria-label="delete clip"
        onClick={onClickPauseAudio}
      >
        <Icon type="close" />
      </Button>
    </StudioClipActionTooltip>
  );
};

export default StudioClipActionDelete;
